import { MarkdownHeading } from '@squareup/dex-ui-shared-markdown-components';
import React, { FC, PropsWithChildren } from 'react';

function createHeading(level: number): FC<PropsWithChildren> {
  const Heading: FC<PropsWithChildren> = ({ children }) => {
    return <MarkdownHeading level={level}>{children}</MarkdownHeading>;
  };
  Heading.displayName = `MdxH${level}`;
  return Heading;
}

const H1 = createHeading(1);
const H2 = createHeading(2);
const H3 = createHeading(3);
const H4 = createHeading(4);

const MdxMdxHeading = { H1, H2, H3, H4 };

export { MdxMdxHeading };
